import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import { Backdrop, Box, Button, Grid, Paper, Stack, Step, Stepper, StepLabel, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import palette from "../../theme/palette";

import { useCookies } from "react-cookie";
import CommonDetails from "../UserDetails/CommonDetails";
import AmbassadorDetailsStep3 from "../UserDetails/AmbassadorDetailsStep3";
import AmbassadorDetailsStep2 from "../UserDetails/AmbassadorDetailsStep2";

import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

import { AppContext } from "../../AppContext";

import TunnelTerminaison from "../Common/TunnelTerminaison";

const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: "#fff",
	},
	root: {
		display: "flex",
		alignItems: "center",
	},
	wrapper: {
		margin: theme.spacing(1),
		position: "relative",
	},

	fabProgress: {
		color: palette.primary.main,
		position: "absolute",
		top: -6,
		left: -6,
		zIndex: 1,
	},
}));
export default function DevenirAmbassadeur(props) {
	const [devMode, setDevMode] = useState(window.location.href.startsWith("http://localhost") || window.location.href.startsWith("http://192.168."));
	const classes = useStyles();

	const dev_state = {
		step: props.step ? parseInt(props.step) : 0,
		gender: "1",
		firstname: "Guillaume",
		lastname: "Besse" + Math.floor(Math.random() * 1000),
		email: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
		pwd1: "******",
		pwd2: "******",
		phone1: "+33637574129",
		phone2: "",
		addr_line1: "7 rue de la rénière",
		addr_line2: "bat B",
		addr_zip_code: "",
		addr_city: "Levallois-Perret",
		every_day: false,
		multiplex: false,
		loaded: false,
	};
	const prod_state = {
		step: props.step ? parseInt(props.step) : 0,
		loaded: false,
	};
	const [cookies, setCookie, removeCookie] = useCookies(["_bkeys"]);
	const [state, setState] = useState(devMode ? dev_state : prod_state);
	const steps = ["Informations personnelles", "Mes coordonnées", "Mon agenda", "Validation"];
	const app = useContext(AppContext);
	useEffect(() => {
		//console.log("useEffect", state, props);
		switch (props.step) {
			case undefined:
				removeCookie("_bkeys");
				removeCookie("_bkuser");
				break;
			default:
				// retrieve data from session

				const requestOptions = {
					method: "GET",
					headers: { "Content-Type": "application/json" },
				};

				fetch("/api/de5528281edf41eb9bcb6542af0cb9ec", requestOptions)
					.then((response) => {
						return response.json();
					})
					.then((res) => {
						switch (res.res) {
							case "ok":
								setState({
									...state,
									...res.payload,
									loaded: true,
								});
								break;

							case "err":
								console.log("erreur", res)
								app.refSnack.current.handleChangeState({ o: true, m: "Erreur: " + res.reason });
								break;
							default:
								break;
						}
					});
		}
	}, []);
	const [verifCode, setVerifCode] = useState(true);
	const handleOpenVerifCode = (event, reason) => {
		setVerifCode(!verifCode);
	};
	const [backDrop, setBackDrop] = useState(false);

	const [err, setErr] = useState("");

	//console.log("DevenirAmbassadeur", state, props);
	if (props.step != undefined && !state.loaded) return;
	//console.log("DevenirAmbassadeur", state, props);
	return (
		<div style="padding: 20px;">

			<Backdrop open={backDrop} className={classes.backdrop}></Backdrop>
			{!backDrop && (
				<Grid container spacing={2}>
					{state.step !== 0 && (
						<Grid item xs={12}>
							<Paper style="padding: 10px;">
								{" "}
								<Stepper activeStep={state.step} alternativeLabel style={{ padding: "0px" }}>
									{steps.map((label) => (
										<Step key={label}>
											<StepLabel>{label}</StepLabel>
										</Step>
									))}
								</Stepper>
							</Paper>
						</Grid>
					)}
					<Grid item xs={12} sm={3}>
						<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
							{state.step === 0 && (
								<div>
									<Typography variant="h6" style="padding-bottom: 20px;">
										Bienvenue
									</Typography>
									<Typography variant="caption">
										En cliquant sur s'inscrire, vous acceptez les conditions générales de Bkeys. Pour en savoir plus sur
										le traitement de vos données et vos droits, veuillez consulter la{" "}
										<a href="https://bkeys.com/cgv">Politique de confidentialité</a> de Bkeys. Vous avez le droit d'accéder à vos données personnelles, d'y apporter toute rectification ou modification.
										Vous avez également la possibilité de supprimer votre compte et de vous opposer à l'utilisation de vos données à des fins de
										prospection commerciale.
									</Typography>
								</div>
							)}
							{/* {state.step === 1 && <Typography variant="h6"></Typography>} */}
							{state.step === 2 && (
								<Stack justifyContent={"flex-start"} spacing={2}>
									<Typography variant="h5" style="font-size: 20px;">
										Remplissez votre agenda !
									</Typography>
									<Typography variant="body1">
										Vous devez renseigner votre planning hebdomadaire de visites ci-contre, en indiquant vos disponibilités pour Bkeys.
									</Typography>
									<Typography variant="body1" >
										Les acquéreurs potentiels pourront ainsi choisir dans les disponibilités que vous avez indiquées un
										créneau pour un rendez-vous de visite.
									</Typography>
									<Typography variant="body1" >
										Rassurez-vous, vous aurez toujours la possiblité de modifier votre planning à n'importe quel
										moment.
									</Typography>
									<Button variant="contained" onClick={() => app.refPopUp.current.handleChangeState(
										{ opened: true, type: "022" }
									)}>Video d'aide</Button>
								</Stack>
							)
							}
							{/* {false && state.step === 2 && (
								<Stack justifyContent={"flex-start"} spacing={2}>
									<Typography variant="h5" style="font-size: 20px;">
										Remplissez votre agenda !
									</Typography>
									<Typography variant="body1">
										Nous vous remercions de bien vouloir renseigner votre planning hebdomadaire.
									</Typography>
									<Typography variant="body1" >
										Les acquéreurs potentiels pourront ainsi choisir dans les disponibilités que vous avez indiquées un
										rendez-vous jusqu'à quatre semaines à l'avance
									</Typography>
									<Typography variant="body1" >
										Rassurez-vous, vous aurez toujours la possiblité de modifier votre planning de disponibilités à n'importe quel
										moment.😅
									</Typography>
									<Paper>
										<Stack flexDirection="row" justifyContent={"flex-start"} alignItems={"center"}>
											<EmojiObjectsIcon color="primary" />
											<Typography variant="h5" color={"primary"} style="margin-left: 10px;">
												Astuce
											</Typography>
										</Stack>
										<Stack flexDirection="row" justifyContent={"flex-start"} alignItems={"flex-start"}>
											<img src="/images/hint-001.png" width="203" />
											<Typography variant="body1" style="padding: 6px">
												Vous pouvez décocher un créneau horaire en cliquant dessus
											</Typography>
										</Stack>
									</Paper>
									<Paper>
										<Stack flexDirection="row" justifyContent={"flex-start"} alignItems={"center"}>
											<EmojiObjectsIcon color="primary" />
											<Typography variant="h5" color={"primary"} style="margin-left: 10px;">
												Astuce
											</Typography>
										</Stack>
										<Stack flexDirection="row" justifyContent={"flex-start"} alignItems={"flex-start"}>
											<img src="/images/hint-002.png" width="200" height="340" />
											<Stack style="height: 100%" justifyContent={"flex-start"} alignItems={"flex-start"}>
												<Typography variant="h5" style="padding: 6px">
													Vous pouvez définir
												</Typography>
												<Typography variant="body1" style="padding: 6px">
													- plusieurs plages horaires (ici 8h00/9h00 et 16h00/17h00)
												</Typography>
												<Typography variant="body1" style="padding: 6px">
													- des jours off (ici mardi)
												</Typography>
											</Stack>
										</Stack>
									</Paper>

								</Stack>
							)} */}
							{/* {false && state.step === 3 &&
								
									
							<Paper style="width: 240px;">
								<Stack flexDirection="row" justifyContent={"flex-start"} alignItems={"center"} style="border-bottom: 1px solid #f0f0e9;">
									<EmojiObjectsIcon color="primary" />
									<Typography variant="h5" color={"primary"} style="margin-left: 10px;">
										Astuce
									</Typography>
								</Stack>
								<Stack justifyContent={"space-between"} alignItems={"center"}>

									<Typography variant="body1" style="padding: 6px; background-color: #FEFEFE;">
										L'email de confirmation
									</Typography>
									<img src="/images/hint-003.png" width="220" height="350" />
								</Stack>

							</Paper>
						
								 */}
						</Paper>
					</Grid>
					<Grid item xs={12} sm={9}>
						<Grid container spacing={2}>
							<Grid item xs={12}>

								<Paper
									style="padding: 8px; "

								>
									<Stack spacing={1}>
										<Typography variant="h5" color="primary">Etre ambassadeur</Typography>
										<Typography>Percevez 50 % des honoraires Bkeys</Typography>
									</Stack>
								</Paper>
							</Grid>
							{/* {props.step === "-1" && (
								<Grid item xs={12}>
									<Paper style="padding: 20px;">
										<Box flexDirection="column" display="flex" alignItems="center" justifyContent="center" p={1} m={1}>
											<Box p={1}>
												<Typography variant="h1">We want YOU !</Typography>
											</Box>
											<Box p={1}>
												<Typography variant="h4">
													<Typography variant="h4">Une inscription rapide et on vous explique tout</Typography>
												</Typography>
											</Box>
										</Box>
									</Paper>
								</Grid>
							)} */}
							<Grid item xs={12}>
								<Paper style="padding: 20px;">
									{props.step === undefined && (
										<CommonDetails
											mode={"A"}
											state={state}
											setState={setState}
											setBackDrop={setBackDrop}

										/>
									)}
									{props.step === "1" && (
										<AmbassadorDetailsStep2
											upperState={state}
											setUpperState={setState}
											setBackDrop={setBackDrop}

											setErr={setErr}
										/>
									)}

									{props.step === "2" && (
										<AmbassadorDetailsStep3
											upperState={{
												...state,
												mode: "ONBOARDING",
												handleChange: null,
											}}
										/>
									)}
									{props.step === "3" && (
										<Stack>
											<TunnelTerminaison state={state} setState={setState} app={app} />

											{(state.email_checked &&
												state.phone1_checked) && <Box
													display="flex"
													alignItems="center"
													justifyContent="flex-end"
													p={1}
													m={1}
													style="padding: 0px; margin: 0px;"

												>
													<Box p={1} style="padding: 0px; margin: 0px; " s>
														<Button
															variant="contained"
															onClick={() => {
																window.location.replace("/dashboarda");
															}}
														>
															Aller dans mon espace
														</Button>
													</Box>
												</Box>
											}
										</Stack>
									)}
								</Paper>
							</Grid>
						</Grid>
					</Grid>

				</Grid >
			)
			}
		</div >
	);
}

//
//
